var map = {
	"./branches-logo-active.svg": "73d6",
	"./devices-logo-active.svg": "4743",
	"./groups-logo-active.svg": "7733",
	"./guest-logo-active.svg": "7126",
	"./reports-logo-active.svg": "8369",
	"./roles-logo-active.svg": "c6cb",
	"./schedule-logo-active.svg": "c57b",
	"./stuff-logo-active.svg": "1b1d",
	"./users-logo-active.svg": "21ae",
	"./visits-logo-active.svg": "17a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b408";